import { ViewType } from "../../../../../../../../Wrap/Constants/Enums/Portfolio/Investments/ViewType";
import { ReportContent } from "../../../../../../../../Wrap/Constants/Enums/Report/ReportContent";
import { ReportFormat } from "../../../../../../../../Wrap/Constants/Enums/Report/ReportFormat";
import { ReportInsight } from "../../../../../../../../Wrap/Constants/Enums/Report/ReportInsight";
import { ReportPerformanceGraph } from "../../../../../../../../Wrap/Constants/Enums/Report/ReportPerformanceGraph";
import { ReportTransaction } from "../../../../../../../../Wrap/Constants/Enums/Report/ReportTransaction";
import { ReportView } from "../../../../../../../../Wrap/Constants/Enums/Report/ReportView";

export const ReportViewArray = [ReportView.TotalPortfolio, ReportView.ProductView];

export const ReportViewMap = {
    [ReportView.TotalPortfolio]: "Total Portfolio",
    [ReportView.ProductView]: "Product View",
};

export const ReportFormatArray = [ReportFormat.PDF, ReportFormat.Word];

export const ReportFormatMap = {
    [ReportFormat.PDF]: "PDF",
    [ReportFormat.Word]: "Word",
};

export const ReportContentMap = {
    [ReportContent.ReportIntroduction]: "Report introduction",
    [ReportContent.AccountDetails]: "Account details",
    [ReportContent.Snapshot]: "Snapshot",
    [ReportContent.Performance]: "Performance",
    [ReportContent.Insights]: "Insights",
    [ReportContent.Valuation]: "Valuation",
    [ReportContent.Transactions]: "Transactions",
};

export const ReportPerformanceGraphMap = {
    [ReportPerformanceGraph.ValuationMoneyMovements]: "Valuation and money movements",
    [ReportPerformanceGraph.ReturnPerformance]: "Return performance",
    [ReportPerformanceGraph.CumulativePerformance]: "Cumulative performance",
    [ReportPerformanceGraph.DiscretePerformance]: "Discrete performance",
};

export const ReportPerformanceGraphArray = [
    ReportPerformanceGraph.ValuationMoneyMovements,
    ReportPerformanceGraph.ReturnPerformance,
    ReportPerformanceGraph.CumulativePerformance,
    ReportPerformanceGraph.DiscretePerformance,
];

export const ReportInsightsMap = {
    [ReportInsight.GeographicAllocation]: "Geographic allocation",
    [ReportInsight.AssetClassAllocation]: "Asset class allocation",
    [ReportInsight.SectorAllocation]: "Sector allocation",
    // [ReportInsight.LargestHoldings]: "Largest holdings",
};

export const ReportInsightsArray = [
    ReportInsight.GeographicAllocation,
    ReportInsight.AssetClassAllocation,
    ReportInsight.SectorAllocation,
    // ReportInsight.LargestHoldings,
];

export const ReportTransactionsMap = {
    [ReportTransaction.Summary]: "Summary",
    [ReportTransaction.MoneyIn]: "Money in",
    [ReportTransaction.MoneyOut]: "Money out",
    [ReportTransaction.Charges]: "Charges",
};

export const ReportTransactionsArray = [
    ReportTransaction.Summary,
    ReportTransaction.MoneyIn,
    ReportTransaction.MoneyOut,
    ReportTransaction.Charges,
];

export const ViewTypeArray = [ViewType.Product, ViewType.Asset];

export const ViewTypeMap = {
    [ViewType.Product]: "Product",
    [ViewType.Asset]: "Asset",
};

export const BenchMark = [
    "7-Day LIBOR (London Interbank Offer Rate)",
    "AC WORLD INDEX",
    "Asia Pacific Excluding Japan",
    "Asia Pacific Including Japan",
    "Bank of England Base Rate",
    "CAC 40",
    "China/Greater China",
    "DAX (main)",
    "DJ Stoxx 50 ETF",
    "Dow Jones Industrial Average",
    "Europe Excluding UK",
    "Europe Including UK",
    "European Smaller Companies",
    "Flexible Investment",
    "FTSE 100 ",
    "FTSE 250 ",
    "FTSE 350 ",
    "FTSE All Share ",
    "FTSE All World ex UK",
    "FTSE All-World ",
    "FTSE Asia Pacific ",
    "FTSE British Government All Stocks",
    "FTSE Eurofirst 100",
    "FTSE Europe ex UK ",
    "FTSE Global Small Cap ",
    "FTSE WMA Stock Market Balanced Index",
    "FTSE WMA Stock Market Conservative Index",
    "FTSE WMA Stock Market Global Growth Index ",
    "FTSE WMA Stock Market Growth Index",
    "FTSE WMA Stock Market Income Index",
    "Global",
    "Global Bonds",
    "Global Emerging Market Bond ",
    "Global Emerging Markets",
    "Global Equity Income",
    "Japan ",
    "Japanese Smaller Companies",
    "Mixed Investment 0%-35% Shrs",
    "Mixed Investment 20%-60% Shrs ",
    "Mixed Investment 40%-85% Shrs ",
    "Money Market",
    "MSCI Emerging Markets ",
    "MSCI EUROPE EXCLUDING UNITED KINGDOM",
    "MSCI World",
    "MSCI WORLD EXCLUDING UNITED KINGDOM ",
    "MSCI World Index",
    "North America",
    "North American Smaller Companies ",
    "Not yet assigned",
    "Personal Pensions ",
    "Property ",
    "Protected",
    "S&P 500",
    "Short Term Money Market",
    "Specialist",
    "Sterling Corporate Bond",
    "Sterling Gilts ",
    "Sterling High Yield",
    "Sterling Strategic Bond",
    "Targeted Absolute Return ",
    "Technology & Telecoms ",
    "Topix ",
    "UK All Companies",
    "UK Equity & Bond Income",
    "UK Equity Income",
    "UK Gilts ",
    "UK Index - Linked Gilts",
    "UK Smaller Companies",
    "Unclassified",
    "United Kingdom Retail Price Index",
];
